//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Mfg.AM.js";
import "../no/DisplayableObject.js";
import "../no/Mfg.js";
let d=[[],[[[],"Ungroup",{},0,0],[["children"],"Add",{},1,1],[["children"],"AddObject",{},1,0],[["num_children"],"GetChildren",{R_:{children:"Mfg.AM.Part[]"}},0,0],[[],"IsLocked",{R_:{bIsLocked:''}},0,1],[[],"Lock",{},0,1],[[],"Unlock",{},0,1],[[],"IsAssembly",{R_:{bIsAssembly:''}},0,0],[[],"Disassemble",{},0,1],[[],"Reassemble",{},0,1],[["objectsToReorder","anchor","reorderBefore"],"ReorderParts",{},3,0],[["children"],"Remove",{},1,0],[["nestingConstraintType"],"SetNestingConstraint",{},1,0],[[],"GetNestingConstraint",{R_:{nestingConstraintType:''}},0,0],[["rotationAngle"],"SetRotationAngle",{},1,0],[[],"GetRotationAngle",{R_:{rotationAngle:''}},0,0],[["intertlockingType"],"SetInterlocking",{},1,0],[[],"GetInterlocking",{R_:{intertlockingType:''}},0,0],[["distanceFromPart"],"SetDistanceFromPart",{},1,0],[[],"GetDistanceFromPart",{R_:{distanceFromPart:''}},0,0]],[]];
SPLM.Mfg.AM.PartGroup = class extends SPLM.DisplayableObject{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Mfg.AM.PartGroup";
        SPLM.c$d(this.Class,d);d=[];
    }
};

export default SPLM;